module.exports = __webpack_public_path__ + "static/media/IBAA_Tour_Logo_Black_CMYK.e2e30846.webp";